<div (click)="onClick($event)" [hidden]="isEditing">
  <ng-content ></ng-content>
</div>
<div [hidden]="!isEditing">
  <textarea #editField [(ngModel)]="value" type="text">
  </textarea>
  <button (click)="onClick($event)">Valider</button>
</div>
